import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a0c20ef")

_pushScopeId("data-v-7a0c20ef")
const _hoisted_1 = { class: "userInfo mt16 flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (v) => {
      return (_openBlock(), _createBlock("div", {
        class: "li",
        style: `width:${100 / _ctx.data.length}%`
      }, _toDisplayString(v.key) + "：" + _toDisplayString(v.value), 5))
    }), 256))
  ]))
})